import "./assets/styles/main.css"
import Verify from "./routes/Verify"
import { useStateValue } from "./context/StateProvider";
import { createBrowserRouter, RouterProvider } from "react-router-dom"
import Wallet from "./routes/Wallet"
import { Fragment, useEffect, useState } from "react"
import Progress from "./components/templates/Progress"
import Notification from "./components/templates/Notification"

const routes = createBrowserRouter([
    {
        path: "/",
        element: <Verify />
    },
    {
        path: "/authenticate",
        element: <Wallet />
    }
])
function App() {
    const [{windowDimensions}, payload] = useStateValue()
    const [isMobile, setIsMobile] = useState(true)
    const handleResize = () => {
        payload ({
            type: "DIMENSIONS"
        })
    }
    useEffect(() => {
        window.addEventListener("resize", handleResize)

        return () => {
            window.removeEventListener("resize", handleResize)
        }
    }, [])
    useEffect(() => {
        if (windowDimensions.width > 850)
            setIsMobile(false)
        else
            setIsMobile(true)
    }, [windowDimensions])
    return (
        isMobile ?
        <Fragment>
            <Progress />
            <Notification />
            <RouterProvider router={routes} />
        </Fragment>
        :
        <div className="not-mobile">
            <div className="note">This app requires the use of a mobile device. Please change your device and try again.</div>
        </div>
    )
}

export default App
